import { gql } from '@apollo/client';

export const GET_ITINERARIES = gql`
  query itineraries($countryCode: String, $username: String) {
    itineraries(countryCode: $countryCode, username: $username) {
      author {
        username
      }
      permlink
      countryCode
      title
      theme
      duration
      places {
        _id
        name
        internalLink
        description
        coordinates
      }
    }
  }
`;

export const ADD_ITINERARY = gql`
  mutation addItinerary($prompt: String!) {
    addItinerary(prompt: $prompt) {
      success
      message
    }
  }
`;

export const EDIT_ITINERARY = gql`
  mutation editItinerary($editItineraryInput: EditItineraryInput!) {
    editItinerary(editItineraryInput: $editItineraryInput) {
      success
      message
    }
  }
`;

export const DELETE_ITINERARY = gql`
  mutation deleteItinerary($permlink: String!) {
    deleteItinerary(permlink: $permlink) {
      success
      message
    }
  }
`;

export const GET_ITINERARY = gql`
  query itinerary($permlink: String!, $author: String!) {
    itinerary(permlink: $permlink, author: $author) {
      author {
        username
        roles
      }
      permlink
      countryCode
      title
      theme
      duration
      places {
        _id
        name
        internalLink
        description
        coordinates
      }
    }
  }
`;
